var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiningRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0569 26.1251L21.3915 20.8347L8.15465 7.6864C5.21066 10.6083 5.21066 15.3452 8.15465 18.2892L16.0569 26.1251Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8341 20.1486C35.8237 23.1369 31.773 24.0665 28.8732 22.7384L26.0842 25.4832L23.428 28.1173L10.4125 40.9779L7.75623 38.3438L26.1949 20.0601C24.8446 17.2046 25.7964 13.176 28.8068 10.2099C32.437 6.62397 37.5945 5.93778 40.3614 8.68255C43.1283 11.4273 42.42 16.5627 38.8341 20.1486Z",
    fill: "#039BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4212 41L25.4279 30.1172L28.0841 27.4832L39.0775 38.3659L36.4212 41Z",
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiningRoom);
export default ForwardRef;